import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { JURIDICAL_EXTENSIONS_REGEX } from "./juridical-extensions.constants";

/**
 * Validates that a name includes a recognized juridical extension
 * (e.g., "SA DE CV", "SAPI DE CV").
 */
export function juridicalExtensionValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || "").toString().trim();
    if (value.length === 0) {
      return null;
    }

    const patterns: RegExp[] = JURIDICAL_EXTENSIONS_REGEX || [];
    const isValid = patterns.some((re) => re.test(value));

    return isValid
      ? null
      : {
          juridicalExtension: {
            message: "Agrega el tipo de sociedad mercantil (ej. SA DE CV, SAPI DE CV, SAS DE CV)",
            value,
          },
        };
  };
}
